import { render, staticRenderFns } from "./StudyTop.vue?vue&type=template&id=4a35454c&lang=pug"
import script from "./StudyTop.vue?vue&type=script&lang=ts"
export * from "./StudyTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports